<div class="app-time-recording-menu" *ngIf="viewModel.project && viewModel.printView">
  <div class="app-time-recording-title">
    <h3 class="app-project-name" [kitText]="componentModel.projectName"></h3>
    <h3 class="app-month-text" [kitText]="componentModel.monthText"></h3>
  </div>
</div>

<kit-bs-table *ngIf="componentModel" [kitModel]="componentModel.tableModel"></kit-bs-table>
